import axios from '@/utils/axios'
const rootUrl = 'flow/website/flow/'
const api = {
  UploadLog: rootUrl + 'uploadLog',
  uploadLogGrtpagination: rootUrl + 'getListPageInfo',
  DelPendingTable: rootUrl + 'del',
  EditPendingEdit: rootUrl + 'edit',
  UploadDetail: rootUrl + 'uploadDetail',
  IntoFlow: rootUrl + 'intoFlow',
  DayPage: rootUrl + 'dayPage',
  getDayPagePageInfo: rootUrl + 'getDayPagePageInfo',
  lockFlowPage: rootUrl + 'lockFlowPage',
  DeleteFlow: rootUrl + 'deleteFlow',
  DayPageByQuarter: rootUrl + 'dayPageByQuarter',
  FlowTransferDetail: rootUrl + 'flowTransferDetail',
  FlowTransfer: rootUrl + 'flowTransfer',
  ApprovalFlow: rootUrl + 'approvalFlow',
  RunBatch: 'flow/website/setting/updateFlowPureDistribution'
}
/**
 * 导入模版配置列表
 */
export function runBatch (parameter) {
  return axios.formRequest.post(api.RunBatch, parameter)
}


/**
 * 导入模版配置列表
 */
export function uploadLog (parameter) {
  return axios.formRequest.post(api.UploadLog, parameter)
}
/**
 * 导入模版配置列表获取分页信息
 */
export function uploadLogGrtpagination (parameter) {
  return axios.formRequest.post(api.uploadLogGrtpagination, parameter)
}
/**
 * 待处理表格删除
 */
export function delPendingTable (upload_ids, data_type, function_name) {
  return axios.formRequest.post(api.DelPendingTable, {
    upload_ids,
    data_type,
    function_name
  })
}
/**
 * 待处理表格重新清洗
 */
export function editPendingEdit (upload_ids, data_type, function_name, parameter = {}) {
  return axios.formRequest.post(api.EditPendingEdit, {
    upload_ids,
    data_type,
    function_name,
    ...parameter
  })
}
/**
 * 上传记录详情接口
 */
export function uploadDetail (page, flow_upload_id, data_type, parameter = {}) {
  return axios.formRequest.post(api.UploadDetail, {
    page,
    flow_upload_id,
    data_type,
    ...parameter
  })
}

/**
 * 流向入库接口  import_scene 1-覆盖，2-叠加
 */
export function intoFlow (
  flow_upload_id_array,
  import_scene,
  data_type,
  function_name,
  is_confirm
) {
  return axios.formRequest.post(api.IntoFlow, {
    flow_upload_id_array,
    import_scene,
    data_type,
    function_name,
    is_confirm
  })
}

/**
 * 关账销售数据
 */
export function lockFlowPage (parameter) {
  return axios.formRequest.post(api.lockFlowPage, parameter)
}
/**
 * 原始流向翻页
 */
export function dayPage (parameter) {
  return axios.formRequest.post(api.DayPage, parameter)
}
/**
 * 原始流向翻页 分页信息
 */
export function getDayPagePageInfo (parameter) {
  return axios.formRequest.post(api.getDayPagePageInfo, parameter)
}

/**
 * 原始流向翻页 按导入人查看
 */
export function dayPageByQuarter (parameter) {
  return axios.formRequest.post(api.DayPageByQuarter, parameter)
}

/**
 * 流向卸载
 */
export function deleteFlow (parameter) {
  return axios.formRequest.post(api.DeleteFlow, parameter)
}
/*
 * 流向迁移详情
 */
export function flowTransferDetail (flow_day_id_array, batch_flow_log_id) {
  return axios.formRequest.post(api.FlowTransferDetail, {
    flow_day_id_array,
    batch_flow_log_id
  })
}

/*
 * 流向迁移详情
 */
export function flowTransfer (parameter) {
  return axios.formRequest.post(api.FlowTransfer, parameter)
}

/*
 * 流向审核 1-通过 2-退回
 */
export function approvalFlow (upload_ids, scene, data_type, function_name) {
  return axios.formRequest.post(api.ApprovalFlow, {
    upload_ids,
    scene,
    data_type,
    function_name
  })
}

/*
 * 亩产分析接口 is_download='0'
 */
export function yieldAnalysis (parameter) {
  return axios.formRequest.post('flow/website/flow/yield_analysis', parameter)
}

/*
 * 原始流向历史数据翻页列表接口  历史组织架构
 */
export function flowHistory (parameter) {
  return axios.formRequest.post('flow/website/flow_history/dayPage', parameter)
}
/*
 * 岗位历史数据列表接口
 */
export function flowHistoryQuarter (parameter) {
  return axios.formRequest.post('flow/website/flow_history/quarter', parameter)
}
/*
 * 获取历史部门，产品，地区列表接口
 */
export function getHistoryInfo (month_date) {
  return axios.formRequest.post('flow/website/flow_history/getHistoryInfo', {
    month_date
  })
}

/*
 * 上传记录详情导出
 */
export function uploadDetailExport (flow_upload_id, flow_upload_id_array) {
  return axios.formRequest.post('flow/website/export/uploadDetailExport', {
    flow_upload_id,
    flow_upload_id_array
  })
}

/*
 * 关账数据表头
 */
export function getFlowtitleAccountSortList (data_type, cls, function_type) {
  return axios.formRequest.post(
    'flow/website/flow_title_sort/FlowtitleSortList',
    {
      data_type,
      cls,
      function_type
    }
  )
}

/*
 * 销售数据表头
 */
export function getFlowtitleSortList (data_type, cls) {
  return axios.formRequest.post(
    'flow/website/flow_title_sort/FlowtitleSortList',
    {
      data_type,
      cls
    }
  )
}

/*
 * 销售数据表头（新）
 */
export function getFlowtitleSortList2 (data_type, scene, function_type) {
  return axios.formRequest.post('flow/website/flow_title_sort/getHeaderList', {
    data_type,
    scene,
    function_type
  })
}

/*
 * 关账数据表头
 */
export function getAboutFlowtitleSortList (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_title_sort/FlowtitleSortList',
    parameter
  )
}

/*
 * 销售数据表头编辑
 */
export function flowtitleSortEdit (title_sort_json) {
  return axios.formRequest.post(
    'flow/website/flow_title_sort/FlowtitleSortEdit',
    {
      title_sort_json
    }
  )
}

/*
 * 下载待验证数据
 */
export function exportCheckUpload (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportCheckUpload',
    parameter
  )
}

/*
 * 待处理 下载待验证数据
 */
export function exportHandleUpload (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportHandleUpload',
    parameter
  )
}

/*
 * 待入库 批量下载
 */
export function exportEntryUpload (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportEntryUpload',
    parameter
  )
}

/*
 * 确认待核验接口
 */
export function checkFlowUpload (parameter) {
  return axios.formRequest.post('flow/website/flow/checkFlowUpload', parameter)
}

/*
 * 确认数据核验无异常接口
 */
export function passToCheckUpload (flow_upload_id) {
  return axios.formRequest.post('flow/website/flow/passToCheckUpload', {
    flow_upload_id
  })
}

/*
 * 单位非必填设置列表
 */
export function notUnitClientPage (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/notUnitClientPage',
    parameter
  )
}

/*
 * 单位非必填设置列表 改 新接口2023.1.8
 */
export function notUnitList (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_client_field_set/getList',
    parameter
  )
}
/*
 * 单位非必填设置
 * client_id,is_not_unit
 */
export function setNotUnitClient (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/setNotUnitClient',
    parameter
  )
}

/*
 * 单位非必填设置  删除
 * client_id,is_not_unit
 */
export function deleteSet (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_client_field_set/deleteSet',
    parameter
  )
}

/*
 * 单位非必填设置  保存
 * client_id,is_not_unit
 */
export function saveSet (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_client_field_set/saveSet',
    parameter
  )
}
/*
 * 固定规则列表
 * goods_class_id
 */
export function getFixedRulesList (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_rule/fixedRulesList',
    parameter
  )
}

/*
 * 固定规则编辑／保存
 */
export function fixedRulesSave (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_rule/fixedRulesSave',
    parameter
  )
}

/*
 * 固定规则选项
 */
export function getFixedRulesOptions () {
  return axios.formRequest.post('flow/website/flow_rule/fixedRulesOptions', {})
}

/*
 * 品类列表
 */
export function getGoodsClassList () {
  return axios.formRequest.post('masterdata/website/goods/goodsClassList', {})
}

/*
 * 固定规则删除
 */
export function fixedRulesDel (flow_fixed_rules_id) {
  return axios.formRequest.post('flow/website/flow_rule/fixedRulesDel', {
    flow_fixed_rules_id
  })
}

/*
 * 更新销售归属
 * flow_day_id,sales_owner,modify_reason
 */
export function updateSalesOwner (parameter) {
  return axios.formRequest.post('flow/website/flow/updateSalesOwner', parameter)
}

/*
 * 手动修改统计日期
 * flow_upload_id,statistics_date
 */
export function updateStatisticsDate (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/updateStatisticsDate',
    parameter
  )
}

/*
 * 手动修改统计日期
 * flow_upload_id
 */
export function getStatisticsDate (flow_upload_id) {
  return axios.formRequest.post('flow/website/flow/getStatisticsDate', {
    flow_upload_id
  })
}

/*
 * 重新清洗销售归属
 * flow_temp_ids
 * flow_upload_ids
 */
export function reloadClearCustomRules (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/reloadClearCustomRules',
    parameter
  )
}

/*
 * 待处理表格 批量处理列表
 */
export function errorBatch (parameter) {
  return axios.formRequest.post('flow/website/flow/errorBatch', parameter)
}
export function errorBatchGetpagination (parameter) {
  return axios.formRequest.post(
    '/flow/website/flow/getErrorBatchPageInfo',
    parameter
  )
}

/*
 * 待处理表格 批量处理列表 批量处理标记
 * ids,upload_ids,type,reason
 */
export function errorTag (parameter) {
  return axios.formRequest.post('flow/website/flow/errorTag', parameter)
}

/*
 * 待处理表格 批量处理列表 无效数据列表
 */
export function errorTagList (parameter) {
  return axios.formRequest.post('flow/website/flow/errorTagList', parameter)
}

/*
 * 入库配置列表
 */
export function configurationGet (type) {
  return axios.formRequest.post('flow/website/setting/configurationGet', {
    type
  })
}

/*
 * 入库配置
 * type
 * json
 */
export function configurationSet (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/configurationSet',
    parameter
  )
}

/*
 * 待入库 批量操作列表
 * date_type
 */
export function uploadBatchDetail (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/uploadBatchDetail',
    parameter
  )
}

/*
 * 待入库 批量操作列表 新接口
 * date_type
 */
export function uploadBatchDetailNew (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/uploadBatchDetailNew',
    parameter
  )
}

/*
 * 待入库 批量操作列表 操作
 *
 */
export function batchOperation (type, data_type) {
  return axios.formRequest.post('flow/website/flow/batchOperation', {
    type,
    data_type
  })
}

/*
 * 待入库 批量操作列表 右上角 操作 新接口
 *
 */
export function batchOperationNew (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/batchOperationNew',
    parameter
  )
}

/*
 * 配送异常查看更多
 *
 */
export function errorBatchMore (parameter) {
  return axios.formRequest.post('flow/website/flow/errorBatchMore', parameter)
}

/*
 * 下载全部
 *
 */
export function flowDownload (flow_upload_id, title_search = '') {
  return axios.formRequest.post('flow/website/flow/download', {
    flow_upload_id,
    title_search
  })
}
/*
 * 代理商流向统计列表
 */
export function actualClientFlow (parameter) {
  return axios.formRequest.post('flow/website/flow/actualClientFlow', parameter)
}
/*
 * 代理商流向明细列表
 */
export function actualFlowPage (parameter) {
  return axios.formRequest.post('flow/website/flow/actualFlowPage', parameter)
}
/*
 * 代理商流向明细导出
 */
export function exportActualFlow (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportActualFlow',
    parameter
  )
}
/*
 * 代理商流向统计导出
 */
export function exportActualClient (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportActualClient',
    parameter
  )
}
/*
 * 查看商业流向最早与最晚时间
 */
export function flowIntervalByClientId (client_id) {
  return axios.formRequest.post('flow/website/flow/flowIntervalByClientId', {
    client_id
  })
}
/*
 * 设置数据处理页面查看逻辑
 */
export function setFlowViewLogic (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/setFlowViewLogic',
    parameter
  )
}
/*
 * 设置入库覆盖配置
 */
export function setFlowCoverSetting (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/setFlowCoverSetting',
    parameter
  )
}
/*
 * 流向统计报告
 */
export function flowReportStatistics (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/flowReportStatistics',
    parameter
  )
}
/*
 * 流向统计报告导出
 */
export function exportFlowReport (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportFlowReport',
    parameter
  )
}
/*
 * 流向统计报告 跑批
 */
export function setFlowReportStatistics (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/setFlowReportStatistics',
    parameter
  )
}
/*
 * 流向统计报告列表
 */
export function flowReportClientPage (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/flowReportClientPage',
    parameter
  )
}
/*
 * 流向统计报告总计
 */
export function flowReportStatisticsByDate (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/flowReportStatisticsByDate',
    parameter
  )
}
/*
 * 重新清洗（待入库）
 */
export function cleanAgain (parameter) {
  return axios.formRequest.post('flow/website/flow/cleanAgain', parameter)
}

/*
 * 原始流向查询(月报)
 */
export function originalPage (parameter) {
  return axios.formRequest.post('flow/website/flow/originalPage', parameter)
}

/*
 * 原始流向详情
 */
export function originalDetail (parameter) {
  return axios.formRequest.post('flow/website/flow/originalDetail', parameter)
}
/*
 * 原始流向详情 分页信息
 */
export function getOriginalDetailPageInfo (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/getOriginalDetailPageInfo',
    parameter
  )
}
/*
 * 删除流向文件
 */
export function flowDel (parameter) {
  return axios.formRequest.post('flow/website/flow/del', parameter)
}

/*
 * 原始流向数据导出
 */
export function exportFlowOriginal (parameter) {
  return axios.formRequest.post(
    'flow/website/Export/exportFlowOriginal',
    parameter
  )
}

/*
 * 商业子公司发货统计
 */
export function clientSubsidiaryStats (parameter) {
  return axios.formRequest.post(
    'flow/website/stats/clientSubsidiaryStats',
    parameter
  )
}

/*
 * 商业子公司发货统计 导出
 */
export function exportFlowSubsidiary (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportFlowSubsidiary',
    parameter
  )
}

/*
 * 原始流向查询(日报)
 */
export function originalDayPage (parameter) {
  return axios.formRequest.post('flow/website/flow/originalDayPage', parameter)
}
export function getOriginalDayPagePageInfo (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/getOriginalDayPagePageInfo',
    parameter
  )
}

/*
 * 流向报表（分销率）-连锁分销统计列表
 */
export function chainDistribution (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_report_form/chainDistribution',
    parameter
  )
}

/*
 * 流向报表（分销率）-导出
 */
export function exportChainDistribution (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_report_form/exportChainDistribution',
    parameter
  )
}

/*
 * 流向报表（分销率）-连锁分销统计数量金额
 */
export function flowReportchainDistributionStat (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_report_form/chainDistributionStat',
    parameter
  )
}

/**
 * 导入连锁门店数量下载模板
 */
export function exportFlowReportFormTemplate (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_report_form/exportTemplate',
    parameter
  )
}

/**
 * 流向报表（ 终端分析）-模板列表
 */
export function FlowReportFormTemplateList (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_report_form/templateList',
    parameter
  )
}

/**
 * 流向报表查看范围配置
 */
export function flowLookAuthList (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/flowLookAuthList',
    parameter
  )
}
/**
 * 流向报表查看范围配置   权限配置
 */
export function flowLookAuthSet (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/flowLookAuthSet',
    parameter
  )
}

/**
 * 流向报表（ 终端分析））-模版操作／启用／停用／删除
 */
export function FlowReportFormTemplateOpreate (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_report_form/templateOpreate',
    parameter
  )
}

/**
 * 流向报表（ 终端分析））-模板详情
 */
export function FlowReportFormTemplateDetail (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_report_form/templateDetail',
    parameter
  )
}

/**
 * 流向报表（ 终端分析）-模板编辑／创建
 */
export function FlowReportFormTemplateEdit (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_report_form/templateEdit',
    parameter
  )
}

/**
 * 流向报表（ 终端分析））-报表导出
 */
export function exportReportForm (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_report_form/exportReportForm',
    parameter
  )
}

/**
 * 流向报表（ 终端分析））-报表列表
 */
export function reportFormList (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_report_form/reportForm',
    parameter
  )
}
/**
 * 流向报表（ 终端分析））客户统计列表
 */
export function customrFormList (parameter) {
  return axios.formRequest.post(
    'flow/website/stats/regionClientChangeStats',
    parameter
  )
}
/**
 * 流向报表（ 终端分析））新增客户明细列表
 */
export function addClientList (parameter) {
  return axios.formRequest.post('flow/website/stats/addClientList', parameter)
}
/**
 * 流向报表（ 终端分析））下降客户明细列表
 */
export function reduceClientList (parameter) {
  return axios.formRequest.post(
    'flow/website/stats/reduceClientList',
    parameter
  )
}

/**
 * 自报数据 职位筛选列表
 */
export function GetjobList (parameter) {
  return axios.formRequest.post('jurisdiction/website/job/jobList', parameter)
}

/*
 * 手动上传记录列表
 */
export function knbManualFlowPage (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/knbManualFlowPage',
    parameter
  )
}

/*
 * 流向上传方式
 */
export function knbCustomUploadFlowOption (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/knbCustomUploadFlowOption',
    parameter
  )
}

/*
 * 手动上传记录汇总
 */
export function knbManualFlowTotal (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/knbManualFlowTotal',
    parameter
  )
}

/*
 * 导出手动上传记录
 */
export function exportKnbManualFlow (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportKnbManualFlow',
    parameter
  )
}

/*
 * 手动上传是否在规定时间内
 */
export function getKnbManualSetting (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/getKnbManualSetting',
    parameter
  )
}

/**
 *  绩效奖金明细表列表接口
 */
export function performanceBonuses (parameter) {
  return axios.formRequest.post('flow/website/bonus/page', parameter)
}
/*
 *绩效奖金删除接口*/
export function performanceBonusesdelete (parameter) {
  return axios.formRequest.post('flow/website/bonus/del', parameter)
}

/**
 * 获取流向数据查询配置
 */
export function jobFlowTitleConfig (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/jobFlowTitleConfig',
    parameter
  )
}

/**
 * 设置流向数据查询配置
 */
export function setJobFlowTitle (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/setJobFlowTitle',
    parameter
  )
}

/**
 * 采购库存获取禁用表头接口
 */
export function getJobFlowTitleConfig (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/getJobFlowTitleConfig',
    parameter
  )
}

/**
 * 获取流向申诉职位配置
 */
export function getAppealJobConfig (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/getAppealJobConfig',
    parameter
  )
}

/**
 * 设置流向申诉职位
 */
export function setAppealJobConfig (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/setAppealJobConfig',
    parameter
  )
}

/**
 * 获取申诉时间列表
 */
export function getFlowAppealTimeList (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/getFlowAppealTimeList',
    parameter
  )
}

/**
 * 设置申诉时间
 */
export function setAppealTime (parameter) {
  return axios.formRequest.post('flow/website/setting/setAppealTime', parameter)
}

/**
 * 流向申诉列表
 */
export function getflowAppealPage (parameter) {
  return axios.formRequest.post('flow/website/flow/flowAppealPage', parameter)
}

/**
 * 流向申诉详情
 */
export function flowAppealRowDetail (parameter) {
  return axios.formRequest.post('flow/website/flow/flowAppealRow', parameter)
}

/**
 * 创建流向申诉
 */
export function setFlowAppeal (parameter) {
  return axios.formRequest.post('flow/website/flow/setFlowAppeal', parameter)
}

/**
 * 流向申诉删除
 */
export function delFlowAppeal (parameter) {
  return axios.formRequest.post('flow/website/flow/delFlowAppeal', parameter)
}

/**
 * 流向申诉导出
 */
export function exportFlowAppeal (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportFlowAppeal',
    parameter
  )
}

/**
 * 厂家申诉导出
 */
export function exportBrlFlowAppeal (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportBrlFlowAppeal',
    parameter
  )
}

/**
 * 产品匹配列表新接口
 */
export function getMatchingGoodsList (parameter) {
  return axios.formRequest.post(
    'flow/website/goods_alias/getGoodsList',
    parameter
  )
}

/**
 * 获取发起流向申诉权限显示
 */
export function getNowAppealDateConfig (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/getNowAppealDateConfig',
    parameter
  )
}

/**
 * 下载档案待处理
 */
export function pendingClient (parameter) {
  return axios.formRequest.post('flow/website/export/pendingClient', parameter)
}
/**
 * 下载产品待处理
 */
export function pendingGoods (parameter) {
  return axios.formRequest.post('flow/website/export/pendingGoods', parameter)
}

/**
 * 上传记录导出
 */
export function exportUploadLog (parameter) {
  return axios.formRequest.post('flow/website/flow/exportUploadLog', parameter)
}

/**
 * 获取发起流向申诉权限显示
 */
export function knbManualCheck (parameter) {
  return axios.formRequest.post('flow/website/flow/knbManualCheck', parameter)
}

/**
 * 采集限制档案列表
 */
export function getfiterPage (parameter) {
  return axios.formRequest.post('flow/website/filter/fiterPage', parameter)
}

/**
 * 创建采集限制
 */
export function createFilter (parameter) {
  return axios.formRequest.post('flow/website/filter/createFilter', parameter)
}

/**
 * 编辑采集限制
 */
export function editFilter (parameter) {
  return axios.formRequest.post('flow/website/filter/editFilter', parameter)
}

/**
 * 校验字段是否存在
 */
export function checkField (parameter) {
  return axios.formRequest.post('flow/website/filter/checkField', parameter)
}

/**
 * 获取子公司数量
 */
export function getSubsidiaryCount (parameter) {
  return axios.formRequest.post(
    'flow/website/filter/getSubsidiaryCount',
    parameter
  )
}

/**
 * 删除过滤接口
 */
export function delFilter (parameter) {
  return axios.formRequest.post('flow/website/filter/delFilter', parameter)
}

/**
 * 过滤详情接口
 */
export function filterRow (parameter) {
  return axios.formRequest.post('flow/website/filter/filterRow', parameter)
}

/**
 * 采集产品规则分页列表
 */
export function getProductPage (parameter) {
  return axios.formRequest.post('flow/website/goods_filter/pageList', parameter)
}

/**
 * 创建采集产品规则
 */
export function createProduct (parameter) {
  return axios.formRequest.post('flow/website/goods_filter/add', parameter)
}

/**
 * 编辑采集产品规则
 */
export function editProduct (parameter) {
  return axios.formRequest.post('flow/website/goods_filter/edit', parameter)
}

/**
 * 删除采集产品规则
 */
export function delProduct (parameter) {
  return axios.formRequest.post('flow/website/goods_filter/del', parameter)
}

/**
 * 采集产品规则详情
 */
export function productRow (parameter) {
  return axios.formRequest.post('flow/website/goods_filter/detail', parameter)
}

/**
 * 异步导出限制字段模板
 */
export function exportFilter (parameter) {
  return axios.formRequest.post('flow/website/export/exportFilter', parameter)
}

/**
 * 销售数据查询固定表头详情
 */
export function LockSettingDetail (parameter) {
  return axios.formRequest.post('crm/website/lock_setting/detail', parameter)
}

/**
 * 销售数据设置固定表头
 */
export function LockSettingAdd (parameter) {
  return axios.formRequest.post('crm/website/lock_setting/add', parameter)
}

/**
 * 服务商关联流向列表
 */
export function kkerServerClientFlowPage (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/kkerServerClientFlowPage',
    parameter
  )
}

/**
 * 院外药房流向数据
 */
export function flowOutHospitalPage (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_out_hospital/page',
    parameter,
  )
}

/*
 * 原始流向查询（日|月）
 */
export function flowOriginalPage (parameter) {
  return axios.formRequest.post('flow/website/flow/flowOriginalPage', parameter)
}

/*
 * 原始流向数据导出（日|月）
 */
export function exportFlowOriginalPage (parameter) {
  return axios.formRequest.post(
    'flow/website/export/flowOriginalPage',
    parameter,
  )
}

/*
 * 原始流向详情（日|月）
 */
export function flowOriginalDetail (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/flowOriginalDetail',
    parameter,
  )
}

/*
 * 原始数据查看详情-导出
 */
export function exportFlowOriginalDetail (parameter) {
  return axios.formRequest.post(
    'flow/website/export/flowOriginalDetail',
    parameter,
  )
}
/**
 * 院外药房流向数据 分页信息
 */
export function getListPageInfo (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_out_hospital/getListPageInfo',
    parameter
  )
}
/**
 * 流向申诉窗口期配置列表
 */
export function getConfigList (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_window_config/configList',
    parameter
  )
}
/**
 * 删除流向申诉窗口期
 */
export function DelConfig (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_window_config/del',
    parameter
  )
}

/**
 * 设置流向申诉窗口期
 */
export function SetConfig (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_window_config/setConfig',
    parameter
  )
}

/**
 * 设置状态
 */
export function editFlowStatus (parameter) {
  return axios.formRequest.post('flow/website/flow/editFlowStatus', parameter)
}

/**
 * 下属人员岗位信息
 */
export function getSonQuarterPage (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/target/sonQuarterPage',
    parameter
  )
}

/**
 * 选择迁移终端
 */
export function quarterClientPage (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/target/quarterClientPage',
    parameter
  )
}

/**
 * 选择迁移岗位 点击确定接口
 */
export function selectSure (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/target/selectSure',
    parameter
  )
}

/**
 * 迁移
 */
export function transport (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/target/transport',
    parameter
  )
}

/**
 * 可选择的字段
 */
export function canSelectList (parameter) {
  return axios.formRequest.post('flow/website/flow/canSelectList', parameter)
}

/**
 * 获取是否已经设置标签
 */
export function getSetLabel () {
  return axios.formRequest.post('flow/website/flow/getSetLabel')
}

/**
 * 获取是否已经设置标签
 */
export function setLabel () {
  return axios.formRequest.post('flow/website/flow/setLabel')
}

/**
 * 全流向数据查询字段设置保存
 */
export function setHeaderData (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_title_sort/setHeaderData',
    parameter
  )
}

/**
 * 全流向数据查询列表字段
 */
export function getTableTitle (data_type, function_type) {
  return axios.formRequest.post('flow/website/flow_title_sort/getTableTitle', {
    data_type,
    function_type
  })
}

/**
 * 同步数据核验设置
 */
export function setCheckFlow (parameter) {
  return axios.formRequest.post('flow/website/setting/setCheckFlow', parameter)
}

/**
 * 获取多文件是否入库
 */
export function getMultFile (parameter) {
  return axios.formRequest.post('flow/website/setting/getMultFile', parameter)
}

/**
 * 商业开户导出
 */
export function exportOpenClient (parameter) {
  return axios.formRequest.post('order/website/open_client/export', parameter)
}

/**
 * 设置多文件是否入库
 */
export function setMultFile (parameter) {
  return axios.formRequest.post('flow/website/setting/setMultFile', parameter)
}

/**
 * 流向设置标签
 */
export function setClientLabels (parameter) {
  return axios.formRequest.post('flow/website/flow/setClientLabels', parameter)
}

/*
 * 原始数据差异

/**
 * 流向异步导入
 */
export function saveUploadFiles (parameter) {
  return axios.formRequest.post(
    '/flow/website/import/saveUploadFiles',
    parameter
  )
}

/**
 * 24小时内异步导入记录
 */
export function latestAsynImportLog (parameter) {
  return axios.formRequest.post(
    '/flow/website/flow/latestAsynImportLog',
    parameter
  )
}

/**
 * 设置映射流向字段
 */
export function getUploadTemplateTitleAlias (parameter) {
  return axios.formRequest.post(
    '/flow/website/import/getUploadTemplateTitleAlias',
    parameter
  )
}

/**
 * 流向异步导入记录
 */
export function asynImportLog (parameter) {
  return axios.formRequest.post('/flow/website/flow/asynImportLog', parameter)
}


/*
 * 抽取日志列表
 */
export function logPage (parameter) {
  return axios.formRequest.post('flow/website/flow/logPage', parameter)
}

/**
 * 创建采集限制
 */
export function createFiter (parameter) {
  return axios.formRequest.post('flow/website/filter/createFiter', parameter)
}

/**
 * 编辑采集限制
 */
export function editField (parameter) {
  return axios.formRequest.post('flow/website/filter/editField', parameter)
}

/**
 * 流向设置标签数据列表
 */
export function getDeliveryStatistics (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/getDeliveryStatistics',
    parameter
  )
}
/**
 * 流向设置标签
 */
export function setDeliveryStatisticsId (parameter) {
  return axios.formRequest.post(
    '/flow/website/flow/setDeliveryStatisticsId',
    parameter
  )
}
/*
 * 流向异步导入取消上传
 */
export function cancelFileImport (parameter) {
  return axios.formRequest.post(
    '/flow/website/import/cancelFileImport',
    parameter
  )
}

/*
 * 原始数据差异
 */
export function flowDiff (parameter) {
  return axios.formRequest.post('flow/website/flow/flowSalesDiff', parameter)
}

/**
 * 低于亩产平均数终端列表
 */
export function lessYieldClient (parameter) {
  return axios.formRequest.post('/flow/website/flow/lessYieldClient', parameter)
}

/*
 * 原始数据差异-导出
 */
export function exportFlowDiff (parameter) {
  return axios.formRequest.post('flow/website/export/flowSalesDiff', parameter)
}

/**
 * 价格预警-上级供应商列表
 */
export function flowSalesPriceDiff (parameter) {
  return axios.formRequest.post(
    '/flow/website/stats/flowSalesPriceDiff',
    parameter
  )
}

/**
 * 客户覆盖统计列表
 */
export function clientCoverStatistics (parameter) {
  return axios.formRequest.post(
    '/flow/website/stats/clientCoverStatistics',
    parameter
  )
}
/**
 * 客户覆盖统计导出
 */
export function exportClientCoverStatistics (parameter) {
  return axios.formRequest.post(
    '/flow/website/export/exportClientCoverStatistics',
    parameter
  )
}
/**
 * 价格分析-省份列表
 */
export function salesPriceAnalysis (parameter) {
  return axios.formRequest.post(
    '/flow/website/stats/salesPriceAnalysis',
    parameter
  )
}

/**
 * 价格分析明细列表
 */
export function salesPriceAnalysisClientList (parameter) {
  return axios.formRequest.post(
    '/flow/website/stats/salesPriceAnalysisClientList',
    parameter
  )
}

/**
 * 价格分析 年份价格分析
 */
export function yearSalesPriceAnalysis (parameter) {
  return axios.formRequest.post(
    '/flow/website/stats/yearSalesPriceAnalysis',
    parameter
  )
}

/**
 * 档案流向上传报告统计
 */
export function reportStatistics (parameter) {
  return axios.formRequest.post(
    '/flow/website/client_flow_upload_report/reportStatistics',
    parameter
  )
}
/**
 * 档案流向上传报告列表
 */
export function reportList (parameter) {
  return axios.formRequest.post(
    '/flow/website/client_flow_upload_report/reportList',
    parameter
  )
}

/**
 * 手动执行设置报告脚本
 */
export function manualSetReportData (parameter) {
  return axios.formRequest.post(
    '/flow/website/client_flow_upload_report/manualSetReportData',
    parameter
  )
}

/**
 * 差异数据列表
 * @param parameter
 */
export function diffPage (parameter) {
  return axios.formRequest.post(
    '/flow/website/flow_original_diff/diffPage',
    parameter
  )
}

/**
 * 差异数据下载
 * @param parameter
 */
export function diffExport (parameter) {
  return axios.formRequest.post(
    '/flow/website/flow_original_diff/diffExport',
    parameter
  )
}

/**
 * 差异数据删除
 * @param parameter
 */
export function diffDel (parameter) {
  return axios.formRequest.post(
    '/flow/website/flow_original_diff/del',
    parameter
  )
}

/**
 * 差异数据取数状态更新
 * @param parameter
 */
export function updateStatus (parameter) {
  return axios.formRequest.post(
    '/flow/website/flow_original_diff/updateStatus',
    parameter
  )
}

/**
 * 差异数据处理
 * @param parameter
 */
export function doStatus (parameter) {
  return axios.formRequest.post(
    '/flow/website/flow_original_diff/doStatus',
    parameter
  )
}

/**
 * 差异数据取数设置
 * @param parameter
 */
export function diffAdd (parameter) {
  return axios.formRequest.post(
    '/flow/website/flow_original_diff/add',
    parameter
  )
}

/**
 * 差异数据设置列表
 * @param parameter
 */
export function diffSetPage (parameter) {
  return axios.formRequest.post(
    '/flow/website/flow_original_diff/page',
    parameter
  )
}

/**
 * 差异数据重新比对
 * @param parameter
 */
export function reDiff (parameter) {
  return axios.formRequest.post(
    '/flow/website/flow_original_diff/repeatDiff',
    parameter
  )
}

/**
 * 销售流向数据分页列表（商业回款-选择关联发货）
 */
export function getFlowDayPageList (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/getFlowDayPageList',
    parameter
  )
}

/**
 * 销售流向数据分页列表（商业回款-选择关联发货）
 */
export function getDistributionErrorTypeEnum (parameter) {
  return axios.formRequest.post(
    'flow/website/business_buy_warning/getDistributionErrorTypeEnum',
    parameter
  )
}
/**
 * 导入重复月报
 */
export function recoverRepeatFileStatus (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/recoverRepeatFileStatus',
    parameter
  )
}

/**
 * 销售流向导出接口
 */
export function exportFlowJurisdiction (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportFlowJurisdiction',
    parameter
  )
}

/**
 * 终端覆盖统计-未购客户明细
 */
export function clientNoSalesLis (parameter) {
  return axios.formRequest.post(
    'flow/website/stats/clientNoSalesList',
    parameter
  )
}

/**
 * 库存有效期预警列表
 */
export function getWarningList (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_stock_valid_date/getWarningList',
    parameter
  )
}

/**
 * 标签检查
 */
export function manualUpdateFlowLabelData (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/manualUpdateFlowLabelData',
    parameter
  )
}

/**
 * 标签检查 下载模板
 */
export function downloadLabelDataTemplate (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/downloadLabelDataTemplate',
    parameter
  )
}

/**
 * 下载批号待处理数据
 */
export function pendingBatchAlias (parameter) {
  return axios.formRequest.post(
    'flow/website/export/pendingBatchAlias',
    parameter
  )
}

/**
 * 获取批号匹配列表
 */
export function getBatchAliasList (parameter) {
  return axios.formRequest.post(
    'flow/website/batch_alias/getBatchAliasList',
    parameter
  )
}

/**
 * 执行批号匹配
 */
export function matchBatchAlias (parameter) {
  return axios.formRequest.post(
    'flow/website/batch_alias/matchBatchAlias',
    parameter
  )
}
/**
 * 新增批号确认
 */
export function addBatchAlias (parameter) {
  return axios.formRequest.post(
    'flow/website/batch_alias/addBatchAlias',
    parameter
  )
}

/**
 * 商业采集监控档案列表
 */
export function getClientList (parameter) {
  return axios.formRequest.post(
    'flow/website/client_collect_monitor/getClientList',
    parameter
  )
}

/**
 * 商业采集监控日报档案列表
 */
export function getClientListDay (parameter) {
  return axios.formRequest.post(
    'flow/website/client_collect_monitor_day/getClientList',
    parameter
  )
}

/**
 * 商业采集监控企业列表汇总
 */
export function getClientListSummary (parameter) {
  return axios.formRequest.post(
    'flow/website/client_collect_monitor/getClientListSummary',
    parameter
  )
}

/**
 * 商业采集监控企业日报列表汇总
 */
export function getClientListSummaryDay (parameter) {
  return axios.formRequest.post(
    'flow/website/client_collect_monitor_day/getClientListSummary',
    parameter
  )
}

/**
 * 页面表头列表
 */
export function getPageTitleList (parameter) {
  return axios.formRequest.post(
    'flow/website/client_collect_monitor/getPageTitleList',
    parameter
  )
}

/**
 * 设置页面表头列表
 */
export function getHeaderSetList (parameter) {
  return axios.formRequest.post(
    'flow/website/client_collect_monitor/getHeaderSetList',
    parameter
  )
}

/**
 * 设置页面表头列表
 */
export function setHeaderMap (parameter) {
  return axios.formRequest.post(
    'flow/website/client_collect_monitor/setHeaderMap',
    parameter
  )
}

/**
 * 获得采集确认统计数据
 */
export function getConfirmSummaryData (parameter) {
  return axios.formRequest.post(
    'flow/website/client_collect_monitor/getConfirmSummaryData',
    parameter
  )
}

/**
 * 采集确认
 */
export function setCollectConfirm (parameter) {
  return axios.formRequest.post(
    'flow/website/client_collect_monitor/setCollectConfirm',
    parameter
  )
}

/**
 * 获得采集确认月份列表
 */
export function getIsConfirmMonths (parameter) {
  return axios.formRequest.post(
    'flow/website/client_collect_monitor/getIsConfirmMonths',
    parameter
  )
}

/**
 * 获取流向文件的采集方式列表
 */
export function dataSourceScreen (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/dataSourceScreen',
    parameter
  )
}
/**
 * 流向所属事业部列表
 */
export function getCustomizedList (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_customized_field_map/getList',
    parameter
  )
}

/**
 * 添加流向所属事业部
 */
export function addMap (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_customized_field_map/addMap',
    parameter
  )
}

/**
 * 编辑流向所属事业部
 */
export function editMap (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_customized_field_map/editMap',
    parameter
  )
}

/**
 * 获取档案上的的采集方式列表
 */
export function clientTypeScreen (parameter) {
  return axios.formRequest.post('flow/website/flow/clientTypeScreen', parameter)
}
/*
 * 删除流向所属事业部
 */
export function deleteMap (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_customized_field_map/deleteMap',
    parameter
  )
}

/**
 * 删除流向所属事业部
 */
export function getChooseOptions (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_customized_field_map/getChooseOptions',
    parameter
  )
}

/**
 * 流向提交到华神金蝶
 */
export function submitToHskjKingdee (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/submitToHskjKingdee',
    parameter
  )
}

/**
 * 获取删除流向列表
 */
export function getDeleteFlowList (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/getDeleteFlowList',
    parameter
  )
}

/**
 * 周期统计配置获取接口
 */
export function getFlowDate (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/getFlowDate',
    parameter
  )
}


/**
 * 周期统计设置周期配置接口
 */
export function flowDateSet (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/flowDateSet',
    parameter
  )
}


/**
 * 周期统计 获取查询周期接口
 */
export function flowGoodsTotalDate (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_goods_total/getDate',
    parameter
  )
}

/**
 * 全国产品销售统计
 */
export function getFlowGoodsPage (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_goods_total/getFlowGoodsPage',
    parameter
  )
}


/**
 * 区域销售统计
 */
export function getFlowRegionPage (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_goods_total/getFlowRegionPage',
    parameter
  )
}




/**
 * 日报入库覆盖配置
 */
export function setDayFlowCoverSetting (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/setDayFlowCoverSetting',
    parameter
  )
}



/**
 * 福牌考核价手动跑批接口
 */
export function manualUpdateFujiaoKhPrice (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/manualUpdateFujiaoKhPrice',
    parameter
  )
}
/**
 * 获取商业采集进度表头
 */
export function getCollectHeader (parameter) {
  return axios.formRequest.post(
    'flow/website/collect/getCollectHeader',
    parameter
  )
}

/**
 * 设置商业采集进度表头
 */
export function setCollectHeader (parameter) {
  return axios.formRequest.post(
    'flow/website/collect/setCollectHeader',
    parameter
  )
}


/**
 * 获取跑批记录接口
 */
export function getManualUpdateFlowLabelDataLog (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/getManualUpdateFlowLabelDataLog',
    parameter
  )
}

/**
 * 特殊商业-列表
 */
export function getSpecialClientPage (parameter) {
  return axios.formRequest.post(
    'flow/website/collect/getSpecialClientPage',
    parameter
  )
}

/**
 * 特殊商业-添加
 */
export function addSpecialClient (parameter) {
  return axios.formRequest.post(
    'flow/website/Collect/addSpecialClient',
    parameter
  )
}


/**
 * 特殊商业-删除
 */
export function delSpecialClient (parameter) {
  return axios.formRequest.post(
    'flow/website/Collect/delSpecialClient',
    parameter
  )
}


/**
 * 查看历史数据列表
 */
export function getHistorySubsequent (parameter) {
  return axios.formRequest.post(
    'flow/website/collect_subsequent/getHistorySubsequent',
    parameter
  )
}

/**
 * 追加问题
 */
export function appendSubsequent (parameter) {
  return axios.formRequest.post(
    'flow/website/collect_subsequent/appendSubsequent',
    parameter
  )
}



/*
 * 待处理 下载待验证数据
 */
export function cloudClean (parameter) {
  return axios.formRequest.post(
    'flow/website/cloud_clean/doClean',
    parameter
  )
}


/*
 * 待处理 下载待验证数据
 */
export function getData (parameter) {
  return axios.formRequest.post(
    'flow/website/cloud_clean/getData',
    parameter
  )
}



/*
 * 待处理 下载待验证数据
 */
export function getCloudLog (parameter) {
  return axios.formRequest.post(
    'flow/website/cloud_clean/getCloudLog',
    parameter
  )
}





/*
 * 新增主数据
 */
export function addClient (parameter) {
  return axios.formRequest.post(
    'flow/website/cloud_clean/addClient',
    parameter
  )
}


/*
 * 下载
 */
export function downloadCloud (parameter) {
  return axios.formRequest.post(
    'flow/website/cloud_clean/downloadCloud',
    parameter
  )
}



